import { default as React, useContext, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { FactCheck } from '@mui/icons-material'
import ListAssessments from './ListAssessments'
import RoleContext from '../auth/RoleContext'

import ListViewCommandBar from '../commandBar/ListViewCommandBar'
import Page from '../layout/Page'
import { ROLES } from '../auth/role'

export default function MyAssessmentsPage (props = {}) {
  const params = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()
  const roleContext = useContext(RoleContext)

  const startLoading = () => {
    setIsLoading(true)
  }

  const stopLoading = () => {
    setIsLoading(false)
  }
  
  const breadcrumb = <span><FactCheck/>&nbsp;My&nbsp;Assessments</span>

  const [showFiltersButton, setShowFiltersButton] = useState(true)
  const [showFilters, setShowFilters] = useState(false)
  const toggleFilters = () => {
    setShowFilters(!showFilters)
  }

  const [showAdd, setShowAdd] = useState(true)

  const addRecord = () => {
    navigate(`/assessments/create`)
  }

  const showAddButton = () => {
    setShowAdd(true)
  }
  const hideAddButton = () => {
    setShowAdd(false)
  }
  
  return (
    <Page { ...props} breadcrumb={breadcrumb} isLoading={isLoading} commandBar={
        <ListViewCommandBar
          showFilters={showFiltersButton}
          toggleFilters={toggleFilters}
          addRecord={addRecord}
          showAdd={roleContext.isQualityManager() && showAdd}/>
        }>
        {/* <Button variant="contained" onClick={sendMessage}>Alert</Button> */}
        {/* <ProfileSelectionControl defaultMfrProfileId={mfrProfileId} onSelectProfile={performSelectManufacturer} /> */}
        <ListAssessments 
          myList={true}
          showFilters={showFilters} 
          showAddRecord={showAddButton} 
          startLoading={startLoading} 
          stopLoading={stopLoading} 
          hideAddRecord={hideAddButton}
          />
      </Page>
  )
}
